import styles from "./index.module.less";
import banner2 from "@/assets/img/banner2.png";

import {
  WkSwitch,
  RadioGroupField,
  RadioField,
  CheckboxGroupField,
  CheckboxField,
  Tree,
  Iconsvg,
  SearchField,
  SelectField,
  ButtonField,
  Pagination,
} from "@wk/components-react16";
import { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCaseList,
  getDictIdByCode,
  getAllDict,
  getDictListById,
  getKsDict,
} from "@/services/history";
import Icon from "@/components/Icon";
import { cloneDeep } from "lodash-es";

const History = () => {
  const navigate = useNavigate();
  const selectOptions = [
    { label: "随机排序", value: "1" },
    { label: "按照时间由近到远排序", value: "2" },
    { label: "按照时间由远到近排序", value: "3" },
  ];

  const [sortValue, setSortValue] = useState("1");

  const [isChecked, setIsChecked] = useState(false);

  const [yearChecked, setYearChecked] = useState([]);

  const [caseTypeChecked, setCaseTypeChecked] = useState([]);

  const [isTreeLoading, setIsTreeLoading] = useState(false);

  const [treeData, setTreeData] = useState([]);

  // 分页
  const [currentPage, setCurrentPage] = useState(1);
  const [historyList, setHistoryList] = useState([]);
  const [total, setTotal] = useState(0);
  const [yearDict, setYearDict] = useState([]);
  const [caseTypeDict, setCaseTypeDict] = useState([]);
  const [ksDict, setKsDict] = useState([]);
  const [isAwardedDict, setIsAwardedDict] = useState([]);
  const [selectedKsIdList, setSelectedKsIdList] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]);
  const [displayMode, setDisplayMode] = useState("row"); // 'row' 或 'box'

  const [searchValue, setSearchValue] = useState({
    name: "",
    pageNo: currentPage,
    isAward: "1",
    belongYear: "",
    caseType: "",
    dept: "",
    pageSize: 10,
    px: "1",
    onlineStatus: "2",
  });

  const onSearch = () => {
    // const value = searchValue.trim();
    const value = cloneDeep(searchValue);
    getCaseLists({
      ...value,
      pageNo: 1,
    });
    setCurrentPage(1);
  };

  // 处理switch切换
  const handleSwitchChange = (checked) => {
    setIsChecked(checked);
    const newSearchValue = {
      ...searchValue,
      isAward: checked ? "1" : "2", // 是否获奖: 1=是, 2=否
    };
    setSearchValue(newSearchValue);
    // 使用新的搜索值进行查询
    getCaseLists({
      ...newSearchValue,
      pageNo: 1,
    });
    setCurrentPage(1);
  };

  // 处理案例类型复选框变化
  const handleCaseTypeChange = (event) => {
    let newCheckedValues;
    if (event.target.checked) {
      newCheckedValues = [...caseTypeChecked, event.target.value];
      setCaseTypeChecked(newCheckedValues);
    } else {
      newCheckedValues = caseTypeChecked.filter(
        (item) => item !== event.target.value
      );
      setCaseTypeChecked(newCheckedValues);
    }
    // 创建新的搜索值
    const newSearchValue = {
      ...searchValue,
      caseType: newCheckedValues.join(","),
    };
    // 更新搜索值
    setSearchValue(newSearchValue);
    // 使用新的搜索值进行查询
    getCaseLists({
      ...newSearchValue,
      pageNo: 1,
    });
    setCurrentPage(1);
  };

  // 处理年份单选框变化
  const handleYearChange = (event) => {
    let newCheckedValues;
    if (event.target.checked) {
      newCheckedValues = [...yearChecked, event.target.value];
      setYearChecked(newCheckedValues);
    } else {
      newCheckedValues = yearChecked.filter(
        (item) => item !== event.target.value
      );
      setYearChecked(newCheckedValues);
    }
    // 创建新的搜索值
    const newSearchValue = {
      ...searchValue,
      belongYear: newCheckedValues.join(","),
    };
    // 更新搜索值
    setSearchValue(newSearchValue);
    // 使用新的搜索值进行查询
    getCaseLists({
      ...newSearchValue,
      pageNo: 1,
    });
    setCurrentPage(1);
  };

  // 清空搜索框
  const onClear = () => {
    setCurrentPage(1);
    getCaseLists({
      ...searchValue,
      pageNo: 1,
    });
  };

  // 点击下一页
  const onNextArrowClick = () => {
    setCurrentPage((prev) => prev + 1);
    getCaseLists({
      ...searchValue,
      pageNo: currentPage + 1,
    }).finally(() => {
      scrollToHistoryList();
    });
  };

  // 点击上一页
  const onPreviousClick = () => {
    setCurrentPage((prev) => prev - 1);
    getCaseLists({
      ...searchValue,
      pageNo: currentPage - 1,
    }).finally(() => {
      scrollToHistoryList();
    });
  };

  // 点击页码
  const onPageClick = (event) => {
    setCurrentPage(event);
    getCaseLists({
      ...searchValue,
      pageNo: event,
    }).finally(() => {
      scrollToHistoryList();
    });
  };

  const goDetail = (id) => {
    console.log(id);
    // 跳转路由到详情页面
    navigate(`/history/detail?id=${id}`);
  };

  const getCaseLists = async (params) => {
    const value = cloneDeep(params);
    const res = await getCaseList(value);
    if (res.code === 200) {
      setHistoryList(res.result.records);
      setTotal(res.result.total);
    }
  };

  /**
   * 获取是否为获奖作品字典表
   * @param {Object} params - 查询参数
   * @param {string} params.code - 案例编码
   * @returns {Promise} - 返回字典
   */
  const getIsAwardedDict = async () => {
    const res = await getAllDict("is_award");
    if (res.code === 200) {
      setIsAwardedDict(res.result);
    }
  };

  /**
   * 获取年份字典表
   *
   */
  const getYearDict = async () => {
    const res = await getAllDict("belong_year");
    if (res.code === 200) {
      setYearDict(
        res.result
          .filter((item) => item.value !== "2018" && item.value !== "2019")
          .map((item) => ({
            name: item.value + "年案例",
            value: item.value,
          }))
      );
    }
  };
  const getCaseTypeDict = async () => {
    const res = await getDictIdByCode({
      code: "al",
    });
    if (res.success) {
      const dictList = await getDictListById({
        dictId: res.result.records[0].id,
      });
      if (dictList.success) {
        setCaseTypeDict(dictList.result.records);
      }
    }
  };
  const getKsTree = async () => {
    const res = await getKsDict();
    if (res.success) {
      setKsDict(res.result);
      // 转换数据格式以适配Tree组件
      const transformedData = transformTreeData(res.result);
      setTreeData(transformedData);
    }
  };

  /**
   * 转换API返回的树形数据为Tree组件需要的格式
   * @param {Array} data - API返回的原始数据
   * @returns {Array} - 转换后的树形数据
   */
  const transformTreeData = (data) => {
    if (!data || !Array.isArray(data)) return [];

    // 递归转换树节点
    const transformNode = (node) => {
      const transformed = {
        title: node.name || node.title || node.text || "未命名", // 尝试各种可能的名称字段
        id: node.id || node.key || node.value, // 尝试各种可能的ID字段
        type: node.children && node.children.length > 0 ? "Chevron" : "Bullet", // 有子节点用Chevron，无子节点用Bullet
        checkbox: true,
        ...node,
      };

      // 如果有子节点，递归处理
      if (node.children && node.children.length > 0) {
        transformed.children = node.children.map((child) =>
          transformNode(child)
        );
      }

      return transformed;
    };

    // 转换顶层节点
    return data.map((item) => transformNode(item));
  };

  const checkTreeData = (node) => {
    const childrenIds = collectIds(node?.children || []);
    const allId = [...childrenIds, node.id];
    const isCheck = selectedKsIdList.includes(node.id);
    let newSelectedId = [];
    if (isCheck) {
      newSelectedId = selectedKsIdList.filter((id) => !allId.includes(id));
    } else {
      const childIds = childrenIds.filter(
        (id) => !selectedKsIdList.includes(id)
      );
      newSelectedId = [...selectedKsIdList, ...childIds, node.id];
    }

    // 如果再次点击当前选中的节点，则取消选择
    // const newSelectedId = selectedKsIdList.includes(node.id)
    //   ? selectedKsIdList.filter((id) => id !== node.id)
    //   : [...selectedKsIdList, node.id];
    setSelectedKsIdList(newSelectedId);
    // 更新搜索条件
    const newSearchValue = {
      ...searchValue,
      dept: newSelectedId.join(","), // 如果ID为空字符串，则不筛选科室
    };
    setSearchValue(newSearchValue);
    // 使用新的搜索值进行查询
    getCaseLists({
      ...newSearchValue,
      pageNo: 1,
    });
    setCurrentPage(1);
  };

  const typeList = useMemo(() => {
    const findNode = (tree, id) => {
      for (let node of tree) {
        // 如果当前节点的ID匹配，返回节点
        if (node.id === id) {
          return node;
        }
        // 如果当前节点有children，递归查找
        if (node.children && node.children.length > 0) {
          let result = findNode(node.children, id);
          // 如果找到，返回结果
          if (result) {
            return result;
          }
        }
      }
      // 如果没有找到，返回null
      return null;
    };
    let caseTypeList = caseTypeDict
      .filter((item) => caseTypeChecked.includes(item.id))
      .map((item) => ({
        name: item.itemText,
        value: item.id,
        type: "caseType",
      }));
    let yearList = yearDict
      .filter((item) => yearChecked.includes(item.value))
      .map((item) => ({
        ...item,
        type: "year",
      }));

    let treeList = selectedKsIdList
      .map((id) => {
        return findNode(treeData, id);
      })
      .filter((item) => item !== null)
      .map((item) => ({
        name: item.title,
        value: item.id,
        type: "tree",
      }));
    console.log([...caseTypeList, ...yearList, ...treeList]);
    return [...caseTypeList, ...yearList, ...treeList];
  }, [
    caseTypeDict,
    yearDict,
    selectedKsIdList,
    caseTypeChecked,
    yearChecked,
    treeData,
  ]);

  const removeType = (item) => {
    let newSelectedId = selectedKsIdList;
    let newYearCheckedValues = yearChecked;
    let newCaseTypeCheckedValues = caseTypeChecked;

    if (item.type === "caseType") {
      newCaseTypeCheckedValues = caseTypeChecked.filter(
        (id) => id !== item.value
      );
      setCaseTypeChecked(newCaseTypeCheckedValues);
    } else if (item.type === "year") {
      newYearCheckedValues = yearChecked.filter((id) => id !== item.value);
      setYearChecked(newYearCheckedValues);
    } else if (item.type === "tree") {
      newSelectedId = selectedKsIdList.filter((id) => id !== item.value);
      setSelectedKsIdList(newSelectedId);
    }
    // 更新搜索条件
    const newSearchValue = {
      ...searchValue,
      dept: newSelectedId.join(","), // 如果ID为空字符串，则不筛选科室
      caseType: newCaseTypeCheckedValues.join(","), // 如果ID为空字符串，则不筛选案例类型
      belongYear: newYearCheckedValues.join(","), // 如果ID为空字符串，则不筛选年份
    };
    setSearchValue(newSearchValue);
    // 使用新的搜索值进行查询
    getCaseLists({
      ...newSearchValue,
      pageNo: 1,
    });
    setCurrentPage(1);
  };

  const scrollToHistoryList = () => {
    const historyListElement = document.querySelector(".history-list");
    if (historyListElement) {
      historyListElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  /**
   * 收集树形数组中所有节点的id
   *
   * @param {Array} tree - 树形数组，每个节点包含id和children字段
   * @returns {Array} 所有节点的id数组
   */
  const collectIds = useCallback((tree) => {
    let ids = []; // 初始化id数组
    for (let node of tree) {
      // 遍历树中的每个节点
      ids.push(node.id); // 将当前节点的id加入数组
      if (Array.isArray(node.children) && node.children.length > 0) {
        // 如果有子节点
        ids = ids.concat(collectIds(node.children)); // 递归收集子节点的id
      }
    }
    return ids; // 返回收集的所有id
  }, []);

  const isHalfCheckedTree = useMemo(() => {
    return (
      selectedKsIdList.length > 0 &&
      selectedKsIdList.length < collectIds(treeData).length
    );
  }, [collectIds, selectedKsIdList, treeData]);

  const halfCheckedNodeIds = useMemo(() => {
    let halfCheckedNodeIds = [];

    // 遍历treeData
    treeData.forEach((node) => {
      // 如果当前节点被选中，则跳过
      // if (selectedKsIdList.includes(node.id)) {
      //   return;
      // }
      // 如果当前节点有子节点，则递归处理子节点
      if (node.children && node.children.length > 0) {
        const childHalfChecked = node.children.some((child) =>
          selectedKsIdList.includes(child.id)
        );
        if (childHalfChecked) {
          halfCheckedNodeIds.push(node.id);
        }
      }
    });
    return halfCheckedNodeIds;
  }, [selectedKsIdList, treeData]);

  useEffect(() => {
    // 获取字典值
    //1.获取 是否获奖(is_award) 字典值
    //2.获取 所属年份(belong_year) 字典值
    //3.获取 案例类型(anli_type) 字典值
    //4.获取 所属科室(belong_ks) 字典值
    // getIsAwardedDict();
    getYearDict();
    getCaseTypeDict();
    getKsTree();
    getCaseLists({
      ...searchValue,
      pageNo: 1,
    });
  }, []);
  return (
    <div className={styles["history"]}>
      <img src={banner2} alt="" className="img-fluid" />
      <div className="history-content">
        <div className="history-content-left">
          {/* <div className="first-box">
            <div className="left-title">是否为获奖作品</div>
            <WkSwitch
              name="isAward"
              isChecked={isChecked}
              size="small"
              srLabel="是否为获奖作品"
              onSwitch={handleSwitchChange}
            />
          </div> */}

          <div className="second-box">
            <div className="left-title">年份选择</div>

            <CheckboxGroupField size="small">
              <CheckboxField
                label="全选"
                isHalfChecked={
                  yearChecked.length > 0 && yearChecked.length < yearDict.length
                }
              >
                <input
                  name="checkbox3"
                  type="checkbox"
                  checked={yearChecked.length > 0}
                  onChange={() => {
                    let newYearCheckedValues;
                    if (yearChecked.length === yearDict.length) {
                      setYearChecked([]);
                      newYearCheckedValues = [];
                    } else {
                      let ids = yearDict.map((item) => item.value);
                      setYearChecked(ids);
                      newYearCheckedValues = ids;
                    }

                    const newSearchValue = {
                      ...searchValue,
                      belongYear: newYearCheckedValues.join(","), // 如果ID为空字符串，则不筛选年份
                    };
                    setSearchValue(newSearchValue);
                    // 使用新的搜索值进行查询
                    getCaseLists({
                      ...newSearchValue,
                      pageNo: 1,
                    });
                    setCurrentPage(1);
                  }}
                />
              </CheckboxField>

              {yearDict.map((item, index) => {
                return (
                  <CheckboxField key={index} label={item.name}>
                    <input
                      type="checkbox"
                      name="checkboxYear"
                      value={item.value}
                      checked={yearChecked.includes(item.value)}
                      onChange={handleYearChange}
                    />
                  </CheckboxField>
                );
              })}
            </CheckboxGroupField>
          </div>

          <div className="third-box">
            <div className="left-title">案例类型</div>
            <CheckboxGroupField size="small">
              <CheckboxField
                label="全选"
                isHalfChecked={
                  caseTypeChecked.length > 0 &&
                  caseTypeChecked.length < caseTypeDict.length
                }
              >
                <input
                  name="checkbox3"
                  type="checkbox"
                  checked={caseTypeChecked.length > 0}
                  onChange={() => {
                    let newCheckedValues;
                    if (caseTypeChecked.length === caseTypeDict.length) {
                      setCaseTypeChecked([]);
                      newCheckedValues = [];
                    } else {
                      let ids = caseTypeDict.map((item) => item.id);
                      setCaseTypeChecked(ids);
                      newCheckedValues = ids;
                    }

                    const newSearchValue = {
                      ...searchValue,
                      caseType: newCheckedValues.join(","),
                    };
                    setSearchValue(newSearchValue);
                    // 使用新的搜索值进行查询
                    getCaseLists({
                      ...newSearchValue,
                      pageNo: 1,
                    });
                    setCurrentPage(1);
                  }}
                />
              </CheckboxField>

              {caseTypeDict.map((item, index) => {
                return (
                  <CheckboxField key={index} label={item.itemText}>
                    <input
                      type="checkbox"
                      name="checkbox"
                      value={item.id}
                      checked={caseTypeChecked.includes(item.id)}
                      onChange={handleCaseTypeChange}
                    />
                  </CheckboxField>
                );
              })}
            </CheckboxGroupField>
          </div>

          <div className="fourth-box">
            <div className="left-title">所属科室</div>

            <CheckboxGroupField size="small">
              <CheckboxField label="全选" isHalfChecked={isHalfCheckedTree}>
                <input
                  name="checkbox3"
                  type="checkbox"
                  checked={selectedKsIdList.length > 0}
                  onChange={() => {
                    let newCheckedValues;
                    const treeIds = collectIds(treeData);

                    if (selectedKsIdList.length === treeIds.length) {
                      setSelectedKsIdList([]);
                      newCheckedValues = [];
                    } else {
                      setSelectedKsIdList(treeIds);
                      newCheckedValues = treeIds;
                    }

                    const newSearchValue = {
                      ...searchValue,
                      dept: newCheckedValues.join(","),
                    };
                    setSearchValue(newSearchValue);
                    // 使用新的搜索值进行查询
                    getCaseLists({
                      ...newSearchValue,
                      pageNo: 1,
                    });
                    setCurrentPage(1);
                  }}
                />
              </CheckboxField>
            </CheckboxGroupField>

            <Tree
              nodes={treeData}
              isLoading={isTreeLoading}
              selectedNodeIds={[]}
              checkedNodeIds={selectedKsIdList}
              onNodeClick={(node) => checkTreeData(node)}
              onCheck={(node) => checkTreeData(node)}
              expandedNodeIds={expandedIds}
              onPrefixClick={(node) => {
                // 点击前缀图标时，展开或收起节点
                const newExpandedIds = expandedIds.includes(node.id)
                  ? expandedIds.filter((id) => id !== node.id)
                  : [...expandedIds, node.id];
                setExpandedIds(newExpandedIds);
              }}
              // halfCheckedNodeIds={halfCheckedNodeIds}
            />
            <div
              className="refresh-btn"
              onClick={() => {
                // 重置所有筛选条件
                setIsChecked(false); // 重置是否获奖
                setYearChecked([]); // 重置年份选择
                setCaseTypeChecked([]); // 重置案例类型选择
                setExpandedIds([]); // 重置展开的节点
                setSelectedKsIdList([]); // 重置选中的科室ID列表
                setSortValue("1"); // 重置排序值
                // 重置搜索值对象
                const resetSearchValue = {
                  name: searchValue.name,
                  pageNo: 1,
                  isAward: "1",
                  belongYear: "",
                  caseType: "",
                  dept: "",
                  pageSize: 10,
                  px: "1",
                };
                setSearchValue(resetSearchValue);

                // 使用重置后的搜索值进行查询
                getCaseLists({
                  ...resetSearchValue,
                  pageNo: 1,
                });
                setCurrentPage(1);
              }}
            >
              <Iconsvg name="refresh" color="#007AC3"></Iconsvg>
              <span>重置</span>
            </div>
          </div>
        </div>

        <div className="history-content-right">
          <div className="right-title">往届U选</div>
          <div className="right-title-desc">
            U选决策—UpToDate临床顾问案例大赛已成功举办七届，上万的临床工作者参与赛事，60余名大赛权威评审专家进行评审。
            在这里，您将看到来自覆盖50+专科的超过2000投稿作品。
          </div>
          <div className="history-search">
            <SearchField
              size="small"
              onSearch={onSearch}
              onClearInput={onClear}
            >
              <input
                type="search"
                id="search-id-1-1"
                name="search-1-1"
                placeholder="请在这里输入关键词"
                value={searchValue.name}
                onChange={(e) =>
                  setSearchValue({
                    ...searchValue,
                    name: e.target.value,
                  })
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    // 当按下回车键时，执行搜索操作
                    onSearch();
                  }
                }}
              />
            </SearchField>
          </div>
          <div className="history-sort">
            <div className="history-sort-text">搜索结果</div>
            <div className="history-sort-select">
              <div className="total-box">{total}个 案例 | 排序方式</div>

              <div className="select-box">
                <SelectField labelFor="select-id-2-1">
                  <select
                    id="select-id-2-1"
                    name="story2-1"
                    value={sortValue}
                    onChange={(e) => {
                      setSortValue(e.target.value);
                      const newSearchValue = {
                        ...searchValue,
                        px: e.target.value,
                      };
                      setSearchValue(newSearchValue);
                      getCaseLists({
                        ...newSearchValue,
                        pageNo: 1,
                      });
                      setCurrentPage(1);
                    }}
                  >
                    {selectOptions.map((item, index) => {
                      return (
                        <option value={item.value} key={index}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </SelectField>
              </div>

              <div className="gird-box">
                <div
                  className={displayMode === "row" ? "active" : ""}
                  onClick={() => setDisplayMode("row")}
                >
                  <Icon icon="hunhezhanzhi" style={{ fontSize: "18px" }} />
                </div>
                <div
                  className={displayMode === "box" ? "active" : ""}
                  onClick={() => setDisplayMode("box")}
                >
                  <Icon icon="qiapianzhanzhi" style={{ fontSize: "18px" }} />
                </div>
              </div>
            </div>
          </div>

          <div className="history-type-list-box">
            {typeList.map((item, index) => {
              return (
                <div className="history-type-list-item" key={index}>
                  <div onClick={() => removeType(item)} className="item-close">
                    <Iconsvg name="close" color="#353535" size={12} />
                  </div>
                  <div className="item-name"> {item.name}</div>
                </div>
              );
            })}
          </div>

          <div
            className={`history-list ${
              displayMode === "box" ? "box-display" : ""
            }`}
          >
            {historyList.map((item, index) => {
              return (
                <div
                  className="history-list-item"
                  key={item.id}
                  onClick={(e) => {
                    // 阻止事件冒泡
                    e.stopPropagation();
                    goDetail(item.id);
                  }}
                >
                  <div className="item-title">{item.name}</div>
                  <div className="item-desc">{item.description}</div>
                  <div className="item-btn">
                    <ButtonField iconPosition={"right"} mode={"ghost"}>
                      <button type="button" onClick={() => goDetail(item.id)}>
                        查看
                        <Iconsvg name="arrow-right"></Iconsvg>
                      </button>
                    </ButtonField>
                  </div>
                </div>
              );
            })}
          </div>

          {historyList.length === 0 && (
            <div className="no-data">无搜索结果</div>
          )}

          <div className="pagination-box">
            {total > 0 && (
              <Pagination
                pageIndex={currentPage}
                controlMode={"controlled"}
                pageCount={Math.ceil(total / 10)}
                onOnNextArrowClick={onNextArrowClick}
                onOnPreviousArrowClick={onPreviousClick}
                onOnPageClick={(event) => onPageClick(event)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
